import { defineQuery } from 'next-sanity'
import { imageFields } from '../atoms'

export const careersIconTextBlockFields = `
  _id,
  _type,
  variant,
  items[]{
    icon {
      ${imageFields}
    },
    heading,
    mainText
  }
`

export const CAREERS_ICON_TEXT_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-icon-text-block"][0]{
    ${careersIconTextBlockFields}
  }
`)
